import React from "react";
// SCSS
import "./teamInfo.scss";


const education = (props) => (
  <div className="team__info flex-center">
    <div>
      <h4 className="font20 weight800">{props.degree}</h4>
      <h4 className="font18 weight800">{props.institution}</h4>
      <p className="font15 weight600"  style={{fontStyle: 'italic'}}>{props.years}</p>
      <p className="font15 weight500">{props.grade}</p>
      <p className="font12 weight500">{props.description}</p>
    </div>
  </div>
);

export default education;
